import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/appUser/importer/appUserImporterActions';

export default importerReducers(actions);
